import { Link } from 'react-router-dom'

export default function NotFoundPage() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4">
      <div className="text-center">
        <div className="w-24 h-24 mx-auto mb-8 rounded-full bg-archive-stone flex items-center justify-center border border-archive-gold/30">
          <span className="font-display text-4xl text-archive-gold">?</span>
        </div>
        <h1 className="font-display text-4xl text-archive-cream mb-4">
          Page Not Found
        </h1>
        <p className="text-archive-muted mb-8 max-w-md">
          The archive you seek has not been catalogued, or may have been
          relocated to a different collection.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/" className="btn-primary">
            Return to Hub
          </Link>
          <Link to="/archives" className="btn-secondary">
            Browse Archives
          </Link>
        </div>
      </div>
    </div>
  )
}
